import { render, staticRenderFns } from "./threshold-filter.vue?vue&type=template&id=06f8823e&"
import script from "./threshold-filter.vue?vue&type=script&lang=js&"
export * from "./threshold-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports